function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import React, { useCallback, useRef, useState } from "react";
import { useUIDSeed } from "react-uid";
import Flicking from "@egjs/react-flicking";
import { motion, AnimatePresence } from "framer-motion";
import { CarouselArrows, Section, SectionHeader, TestimonialSlide } from "../../molecules";
import { Body, Heading } from "../../atoms";
export var TestimonialCarousel = function(param) {
    var title = param.title, testimonials = param.testimonials, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    var flickingRef = useRef(null);
    var ref = _slicedToArray(useState(0), 2), activeIndex = ref[0], setActiveIndex = ref[1];
    var currentTestimonial = testimonials[activeIndex];
    var handlePrev = useCallback(function() {
        var ref;
        (ref = flickingRef.current) === null || ref === void 0 ? void 0 : ref.prev();
    }, []);
    var handleNext = useCallback(function() {
        var ref;
        (ref = flickingRef.current) === null || ref === void 0 ? void 0 : ref.next();
    }, []);
    var handleChangeOrRestore = useCallback(function(event) {
        setActiveIndex(event.index);
    }, []);
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        backgroundColor: "offdefault",
        className: className
    }, title && /*#__PURE__*/ React.createElement("div", {
        className: "mb-9 md:mb-12"
    }, /*#__PURE__*/ React.createElement(SectionHeader, {
        title: title
    })), /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto gap-7 md:gap-6 md:grid-cols-[minmax(0,1fr)_auto]"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-1 grid-flow-row auto-rows-auto"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "col-start-1 row-start-1 grid gap-5 grid-cols-1 grid-flow-row auto-rows-auto md:grid-cols-[1fr_2fr] md:gap-7"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(AnimatePresence, {
        mode: "wait"
    }, currentTestimonial && /*#__PURE__*/ React.createElement("div", {
        key: String(activeIndex)
    }, /*#__PURE__*/ React.createElement(motion.div, {
        initial: {
            opacity: 0,
            y: "50%"
        },
        animate: {
            opacity: 1,
            y: "0px"
        },
        exit: {
            opacity: 0,
            y: "-50%"
        },
        transition: {
            damping: 1000
        }
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "h4"
    }, currentTestimonial.authorName)), !!currentTestimonial.authorRole && /*#__PURE__*/ React.createElement(motion.div, {
        initial: {
            opacity: 0,
            y: "50%"
        },
        animate: {
            opacity: 1,
            y: "0px"
        },
        exit: {
            opacity: 0,
            y: "-50%"
        },
        transition: {
            damping: 1000,
            delay: 0.1
        },
        className: "max-w-[14rem]"
    }, /*#__PURE__*/ React.createElement(Body, {
        className: "mt-2 text-fg-default/40 md:mt-3"
    }, currentTestimonial.authorRole))))), /*#__PURE__*/ React.createElement(Flicking, {
        ref: flickingRef,
        moveType: "strict",
        firstPanelSize: "100%",
        onWillChange: handleChangeOrRestore,
        onWillRestore: handleChangeOrRestore
    }, testimonials.map(function(testimonial) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(testimonial),
            className: "flicking-panel w-full"
        }, /*#__PURE__*/ React.createElement(TestimonialSlide, _extends({}, testimonial)));
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "flex items-center justify-start col-start-1 row-start-1 pointer-events-none"
    }, /*#__PURE__*/ React.createElement(CarouselArrows, {
        className: "hidden pointer-events-auto md:flex",
        canGoBack: activeIndex > 0,
        canGoForward: activeIndex < testimonials.length - 1,
        onPrev: handlePrev,
        onNext: handleNext
    }))), /*#__PURE__*/ React.createElement(CarouselArrows, {
        className: "flex md:hidden",
        canGoBack: activeIndex > 0,
        canGoForward: activeIndex < testimonials.length - 1,
        onPrev: handlePrev,
        onNext: handleNext
    }))));
};

//# sourceMappingURL=TestimonialCarousel.js.map